import { useCallToAttentionCommand } from "./hooks/useCallToAttentionCommand";
import FormCallToAttention from "./components/FormCallToAttention";

function CallToAttention() {
  const { callToAttention, handleChange, createCallToAttention, errors } =
    useCallToAttentionCommand();

  const handleSubmit = () => {
    createCallToAttention();
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Registrar llamados de atención</h1>
      </header>
      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro de infracciones. Asegúrate de completar
              todos los campos requeridos.
            </p>
            <FormCallToAttention
              callToAttention={callToAttention}
              onChange={handleChange}
              onSubmit={handleSubmit}
              errors={errors}
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default CallToAttention;
